import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { formatPrice } from "@/lib/utils";

export const ProductCard = ({ product, index }) => {
    const { lang, t } = useLang();
    const price = product.options.roseCounts
        ? product.options.roseCounts[0].price
        : product.basePrice;
    const isPack = product.id === "romantic-pack-supreme";

    return (
        <div
            data-testid={`product-card-${index + 1}`}
            className="group flex flex-col h-full w-full"
        >
            <Link
                to={`/regalo/${product.handle}`}
                className="relative block aspect-square rounded-xl overflow-hidden bg-stone-100"
            >
                <img
                    src={product.images[0]}
                    alt={product.name[lang]}
                    loading={index < 2 ? "eager" : "lazy"}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                />
                {isPack && product.badge && (
                    <span className="absolute top-2.5 left-2.5 bg-bordeaux text-white text-[10px] font-semibold uppercase tracking-wide px-2 py-1 rounded-md">
                        {product.badge[lang]}
                    </span>
                )}
            </Link>
            <div className="pt-3 pb-1 px-0.5 flex flex-col flex-1">
                <Link to={`/regalo/${product.handle}`}>
                    <h3 className="font-serif text-lg sm:text-xl text-stone-900 leading-snug min-h-[3.3rem] sm:min-h-[3.4rem]">
                        {product.name[lang]}
                    </h3>
                </Link>
                <p className="mt-1 font-serif italic text-2xl text-bordeaux" data-testid={`product-card-price-${index + 1}`}>
                    <span className="text-base text-stone-500">{t("products.from")} </span>
                    {formatPrice(price, lang)}
                </p>
                <Link
                    to={`/regalo/${product.handle}`}
                    data-testid={`product-card-button-${index + 1}`}
                    className="mt-auto pt-3 block w-full"
                >
                    <span className="block w-full text-center text-[15px] font-medium py-2.5 px-3 rounded-lg bg-bordeaux text-white border border-bordeaux hover:bg-bordeaux-deep transition-colors duration-200">
                        {t("products.btnCustomize")}
                    </span>
                </Link>
            </div>
        </div>
    );
};
